import {LoanCreationType} from '../shared/model/creation-type.model';

export const CREATION_TYPE_OPTIONS = [
  {label: 'New Loan', value: LoanCreationType.NEW_LOAN},
  {label: 'Reloan', value: LoanCreationType.RELOAN},
  {label: 'Additional loan', value: LoanCreationType.ADDITIONAL_LOAN},
  {label: 'Extension', value: LoanCreationType.EXTENSION},
  {label: 'Consolidation', value: LoanCreationType.CONSOLIDATION},
  {label: 'Renewal', value: LoanCreationType.RENEWAL},
];